import React from 'react';
import { OrderRouteLayer } from '@src/features/order/components';
import { OrderMissionEntity } from '@src/features/order/entities';

type HistoryOrderRouteProps = {
  order: OrderMissionEntity;
  droneVariant: 'idleGray' | 'error';
};

const HistoryOrderRoute: React.FC<HistoryOrderRouteProps> = ({ order, droneVariant }) => (
  <OrderRouteLayer order={order} droneVariant={droneVariant} />
);

export default HistoryOrderRoute;
